/* WOOF drawers (size guide): open from [data-ds-size-open], close on scrim, X or Escape. */
(() => {
  if (window.dsDrawerReady) return;
  window.dsDrawerReady = true;
  let lastFocus = null;

  const panelOf = (d) => d.querySelector('[role="dialog"]');

  const open = (drawer) => {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.hidden = false;
    requestAnimationFrame(() => {
      drawer.classList.add('is-open');
      document.body.classList.add('ds-lock');
      const p = panelOf(drawer);
      if (p) p.focus({ preventScroll: true });
    });
  };

  const close = (drawer) => {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    document.body.classList.remove('ds-lock');
    setTimeout(() => {
      if (!drawer.classList.contains('is-open')) drawer.hidden = true;
    }, 450);
    if (lastFocus) lastFocus.focus({ preventScroll: true });
  };

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-ds-size-open]');
    if (opener) {
      e.preventDefault();
      open(document.querySelector('[data-ds-drawer="size"]'));
      return;
    }
    const closer = e.target.closest('[data-ds-drawer-close]');
    if (closer) close(closer.closest('[data-ds-drawer]'));
  });

  document.addEventListener('keydown', (e) => {
    const drawer = document.querySelector('[data-ds-drawer].is-open');
    if (!drawer) return;
    if (e.key === 'Escape') {
      e.preventDefault();
      close(drawer);
      return;
    }
    if (e.key !== 'Tab') return;
    const items = Array.from(drawer.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])')).filter(
      (el) => el.offsetParent !== null
    );
    if (!items.length) return;
    const first = items[0];
    const last = items[items.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === panelOf(drawer))) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });

  document.addEventListener('shopify:section:select', (e) => {
    const d = e.target.querySelector && e.target.querySelector('[data-ds-drawer]');
    if (d) open(d);
  });
  document.addEventListener('shopify:section:deselect', (e) => {
    const d = e.target.querySelector && e.target.querySelector('[data-ds-drawer]');
    if (d) close(d);
  });
})();
